
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { UseFormReturn } from 'react-hook-form';
import { ProfileFormValues } from '@/lib/schemas/profileSchema';

interface PasswordChangeSectionProps {
  form: UseFormReturn<ProfileFormValues>;
  passwordChangeMode: boolean;
  setPasswordChangeMode: (value: boolean) => void;
}

const PasswordChangeSection: React.FC<PasswordChangeSectionProps> = ({
  form,
  passwordChangeMode,
  setPasswordChangeMode
}) => {
  if (!passwordChangeMode) {
    return (
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => setPasswordChangeMode(true)}
        className="w-full"
      >
        Change Password
      </Button>
    );
  }

  return (
    <>
      <FormField
        control={form.control}
        name="currentPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Current Password</FormLabel>
            <FormControl>
              <Input type="password" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="newPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>New Password</FormLabel>
            <FormControl>
              <Input type="password" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="confirmPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Confirm New Password</FormLabel>
            <FormControl>
              <Input type="password" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <Button 
        type="button" 
        variant="ghost" 
        onClick={() => {
          setPasswordChangeMode(false);
          form.setValue('currentPassword', '');
          form.setValue('newPassword', '');
          form.setValue('confirmPassword', '');
        }}
        size="sm"
      >
        Cancel Password Change
      </Button>
    </>
  );
};

export default PasswordChangeSection;
